import React from "react";
import { Chip } from "Components/Base/DataDisplay/Chip";
import { LockIcon } from "Components/Icons/";

/**
 * Configuration object for different chip types used in learning activity cards
 * @type {Object.<string, {color: string, sx: Object, icon?: JSX.Element}>}
 */
const LEARNING_ACTIVITY_CHIPS = {
  mandatory: {
    color: "error",
    sx: { backgroundColor: "var(--colorErrorLight)" },
  },
  completed: {
    color: "success",
    sx: { backgroundColor: "var(--colorSuccessLight)" },
  },
  teams: {
    color: "warning",
    sx: { backgroundColor: "var(--colorWarningLight)" },
  },
  requested: {
    color: "warning",
    sx: { backgroundColor: "var(--colorWarningLight)" },
  },
  attest: {
    color: "warning",
    sx: { backgroundColor: "var(--colorWarningLight)" },
  },
  survey: {
    color: "warning",
    sx: { backgroundColor: "var(--colorWarningLight)" },
  },
  locked: {
    color: "warning",
    icon: <LockIcon />,
    sx: { backgroundColor: "var(--colorWarningLight)" },
  },
  administrator: {
    color: "success",
    sx: { backgroundColor: "var(--colorSuccessLight)" },
  },
};

/**
 * Renders a chip with the specified type and label
 * @param {Object} props - Component props
 * @param {string} props.type - Type of chip to render (must be a key in LEARNING_ACTIVITY_CHIPS)
 * @param {string} props.label - Text to display in the chip
 * @returns {JSX.Element} Rendered chip component
 */
const ChipRenderer = ({ type, label }) => {
  const config = LEARNING_ACTIVITY_CHIPS[type];
  return (
    <Chip
      label={label}
      size="small"
      variant="outlined"
      color={config.color}
      sx={config.sx}
      icon={config.icon}
    />
  );
};

export const AdministratorChip = ({ label }) => (
  <ChipRenderer type="administrator" label={label} />
);
export const MandatoryChip = ({ label }) => (
  <ChipRenderer type="mandatory" label={label} />
);
export const CompletedChip = ({ label }) => (
  <ChipRenderer type="completed" label={label} />
);
export const TeamsChip = ({ label }) => (
  <ChipRenderer type="teams" label={label} />
);
export const RequestedChip = ({ label }) => (
  <ChipRenderer type="requested" label={label} />
);
export const AttestChip = ({ label }) => (
  <ChipRenderer type="attest" label={label} />
);
export const SurveyChip = ({ label }) => (
  <ChipRenderer type="survey" label={label} />
);
export const LockedChip = ({ label }) => (
  <ChipRenderer type="locked" label={label} />
);
